export default {
  setAuth: (state, payload) => {
    state.shopId = payload.shopId;
    state.token = payload.token;
  },
  setShopId: (state, shopId) => {
    state.shopId = shopId;
  },
  setShopifyToken: (state, token) => {
    state.shopifyToken = token;
  },
  removeAuth: state => {
    state.shopId = null;
    state.token = null;
  },
};
